import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NotificationListSharedComponent } from './notification.list.component';

import { ButtonSharedModule } from '../../atoms/button/button.module';
import { IconSharedModule } from '../../atoms/icon/icon.module';

import { TransformAgoModule } from '../../../shared/pipe/ago/pipe.ago.module';

@NgModule({
    declarations: [
        NotificationListSharedComponent
    ],
    imports: [
        CommonModule,
        ButtonSharedModule,
        IconSharedModule,
        TransformAgoModule
    ],
    exports: [
        NotificationListSharedComponent
    ]
})

// tslint:disable-next-line:no-unnecessary-class
export class NotificationListSharedModule {}
